import type { ChangeEvent } from "react";
import { useEffect, useRef } from "react";

interface UploadPdfButtonProps {
  /** Arquivos soltos ou a árvore de uma pasta (cada `File` com `webkitRelativePath`). */
  onFilesSelected: (files: FileList) => void;
}

const BUTTON_CLASS =
  "shrink-0 rounded border border-ink-600 bg-ink-800 px-3 py-1.5 text-xs font-medium text-ink-100 hover:border-emerald-600 hover:bg-ink-700";

export function UploadPdfButton({ onFilesSelected }: UploadPdfButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const folderInputRef = useRef<HTMLInputElement>(null);

  // `webkitdirectory` não está na tipagem do React; pelo atributo vale em
  // Chrome, Edge, Firefox e Safari. Um mesmo input não escolhe arquivo e pasta.
  useEffect(() => {
    folderInputRef.current?.setAttribute("webkitdirectory", "");
  }, []);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      event.target.value = "";
      return;
    }
    onFilesSelected(files);
    // Zerado depois de entregue, para escolher a mesma pasta de novo disparar
    // o `change`.
    event.target.value = "";
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,application/postscript,application/illustrator,image/jpeg,image/png,image/tiff,.pdf,.ai,.jpg,.jpeg,.png,.tif,.tiff"
        multiple
        className="hidden"
        aria-hidden="true"
        onChange={handleChange}
      />
      <input
        ref={folderInputRef}
        type="file"
        multiple
        className="hidden"
        aria-hidden="true"
        onChange={handleChange}
      />
      <button type="button" className={BUTTON_CLASS} onClick={() => inputRef.current?.click()}>
        Enviar arquivos
      </button>
      <button type="button" className={BUTTON_CLASS} onClick={() => folderInputRef.current?.click()}>
        Enviar pasta
      </button>
    </>
  );
}
